<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-container fluid>
            <v-card>
                <v-app-bar dark color="accent">
                    <v-icon class="mr-3">mdi-account-circle</v-icon>
                    <v-toolbar-title>Profile</v-toolbar-title>
                    <v-toolbar-title/>
                </v-app-bar>
                <v-container height="700px" fluid>
                    <v-row>
                        <v-col cols="12" md="12" lg="12" class="text-center">
                            <v-row no-gutters>
                                <v-col class="pa-2 text-center" cols="12">

                                        <label for="image">
                                            <input type="file" name="image" id="image" style="display:none;"/>
                                            <v-avatar size=200>
                                            <img src="../assets/qistina.jpeg" alt="John">
                                            </v-avatar>
                                        </label>
                                </v-col>
                                <v-col class="py-0 text-center">
                                    <v-list-item light>
                                        <v-list-item-content>
                                            <v-list-item-title class="title align-center">Qistina </v-list-item-title>
                                            <v-list-item-subtitle></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-col>
                            </v-row>
                            <v-row class="move-right" justify="center">
                                <v-col cols="12" lg="3" md="3" class="mt-lg-10">
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <tbody>
                                            <tr>
                                                <td class="profile-label table-text">Username</td>
                                                <td class="table-text">:</td>
                                                <td class="table-text">qistina.hashim</td>
                                            </tr>
                                            <tr>
                                                <td class="profile-label table-text">Name</td>
                                                <td class="table-text">:</td>
                                                <td class="table-text">Nurul Qistina Hashim</td>
                                            </tr>
                                            <tr>
                                                <td class="profile-label table-text">Staff ID</td>
                                                <td class="table-text">:</td>
                                                <td class="table-text">2215</td>
                                            </tr>
                                            <tr>
                                                <td class="profile-label table-text">Branch</td>
                                                <td class="table-text">:</td>
                                                <td class="table-text">Alor Setar</td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <span class="small-text">*Click on profile picture to upload new profile picture</span>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'UserProfile',
        data () {
            return {
                items: [
                    {
                        text: 'Home',
                        disabled: true,
                        href: 'breadcrumbs_dashboar'
                    },
                    {
                        text: 'Edit Profile',
                        disabled: true,
                        href: 'breadcrumbs_link_1'
                    }
                ]
            }
        }
    }
</script>
<style scoped>
    .v-breadcrumbs{
        padding: 7px 0px 0px 0px  !important;
    }
    .text-color{
        color: #5bc1aa;
    }
    .cardStyle{
    }
</style>
<style>
    .v-text-field.v-text-field--enclosed .v-text-field__details{
        margin-bottom: -15px !important;
    }
    .profile-label {
        font-weight: bold;
    }
    .table-text {
        text-align: left;
    }
    .move-right {

    }

    .small-text{
        font-size: smaller;
    }
</style>
